<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("helpdesk") }}</div>

    <!-- Estadísticas principales -->
    <div class="columns mb-6" v-if="stats">
      <div class="column">
        <div class="box has-text-centered">
          <p class="heading">{{ $t("total_tickets") }}</p>
          <p class="title">{{ stats.total_tickets || 0 }}</p>
        </div>
      </div>
      <div class="column">
        <div class="box has-text-centered">
          <p class="heading">{{ $t("open_tickets") }}</p>
          <p class="title has-text-danger">{{ getOpenTicketsCount() }}</p>
        </div>
      </div>
      <div class="column">
        <div class="box has-text-centered">
          <p class="heading">{{ $t("closed_tickets") }}</p>
          <p class="title has-text-success">{{ getClosedTicketsCount() }}</p>
        </div>
      </div>
    </div>

    <!-- Cards de navegación -->
    <div class="grid is-col-min-10">
      <div class="cell" @click="manage_tickets">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2706/2706950.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">{{ $t("tickets") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="manage_agents">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/10857/10857085.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">{{ $t("agents") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="manage_categories">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3209/3209051.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("categories") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="manage_status">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3094/3094837.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("status_plural") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="manage_priorities">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2885/2885755.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("priorities") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="view_settings">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3524/3524659.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("helpdesk_settings") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="view_reports">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2920/2920277.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("helpdesk_reports") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { get, warning_message, error_message } from "@/utils";

export default {
  name: "HelpdeskIndex",
  data() {
    return {
      is_loading: false,
      stats: null,
    };
  },
  methods: {
    manage_tickets() {
      this.$router.push({ path: "/helpdesk/tickets" });
    },
    manage_agents() {
      this.$router.push({ path: "/helpdesk/agents" });
    },
    manage_categories() {
      this.$router.push({ path: "/helpdesk/categories" });
    },
    manage_status() {
      this.$router.push({ path: "/helpdesk/status" });
    },
    manage_priorities() {
      this.$router.push({ path: "/helpdesk/priorities" });
    },
    view_settings() {
      this.$router.push({ path: "/helpdesk/settings" });
    },
    view_reports() {
      this.$router.push({ path: "/helpdesk/reports" });
    },
    load_stats() {
      let v = this;
      v.is_loading = true;

      get("/helpdesk/ticket/stats")
        .then((stats) => {
          v.stats = stats;
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.is_loading = false;
        });
    },
    getOpenTicketsCount() {
      if (!this.stats || !this.stats.tickets_by_status) return 0;
      return this.stats.tickets_by_status
        .filter((item) => !item.status.is_closed_status)
        .reduce((sum, item) => sum + parseInt(item.count), 0);
    },
    getClosedTicketsCount() {
      if (!this.stats || !this.stats.tickets_by_status) return 0;
      return this.stats.tickets_by_status
        .filter((item) => item.status.is_closed_status)
        .reduce((sum, item) => sum + parseInt(item.count), 0);
    },
  },
  created() {
    this.load_stats();
  },
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}

.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
